import React, { useEffect, useState } from "react";
import ShowAllStyles from "./ShowAll.styles";
import customTableStyles from "../../../../global/components/CustomTable/customTable.styles";
import {
  Box,
  Button,
  Grid,
  Popover,
  Typography,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  MenuItem,
  Chip,
} from "@mui/material";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";
import YhTable, { YhTableColumn, YhTableCellParams } from "../../../../ui/YhTable";
import YhInput from "../../../../ui/YhInput";

import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import PhoneListIcon from "../../../../assets/icons/phone-list-icon.svg";
import EmailListIcon from "../../../../assets/icons/email-list-icon.svg";

import AddNewTeam from "../AddNewTeam/AddNewTeam";
import {
  changeStatusApi,
  changeUserPassword,
  getAllProject,
  getDateWiseTeam,
  movingProject,
} from "./ShowAllService";
import notifiers from "../../../../global/constants/NotificationConstants";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import CustomRadioButton from "../../../../global/components/CustomRadioButton/CustomRadioButton";
import customErrorHandler from "../../../../utils/customErrorHandler";
import AddLoan from "../AddLoan/AddLoan";
import LoanList from "../AddLoan/RoleTabContent";

import { store } from "../../../../utils/store";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";
import { ReactComponent as VerticalDotIcon } from "../../../../assets/icons/verticalDot.svg";
import { DateRangePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { getTeamList } from "../../../MetaData/components/MetaList/components/AddTeamMetaList/CreateService";
import { applyLicenseKey } from "../../../../utils/License";
import {
  PORTAL_FILTERS,
  portalLabelFromRow,
  portalChipColor,
  filterPortalRows,
  mappingStatusLabel,
} from "../../aggregatorPortalUtils";
import { useSelector } from "react-redux";
import { selectActiveOrganizationId } from "../../../../redux/authSlice";

const SearchSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const ShowAll = (props:any) => {
  // LicenseInfo.setLicenseKey(
  //   "74c3b9c03880c75b0883807cc9f17463Tz05OTMwMCxFPTE3NTk1NTk4NjAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg=="
  // );
  useEffect(() => {
    applyLicenseKey();
  }, []);
  const classes = ShowAllStyles;
  const customTableClasses = customTableStyles;
  const privileges = store.getState().auth?.privileges || {};
  const activeOrganizationId = useSelector(selectActiveOrganizationId) || "";
  const [search, setSearch] = useState<string>("");
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [userDataSource1, setUserDataSource1] = useState<any>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [addNewTeamDialog, setNewTeamDialog] = useState<boolean>(false);
  const [getAddTeamMetaDataDylog, setGetAddTeamMetaDataDylog] =
    useState<boolean>(false);
  const [fixData, setFixData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const userPerPage = 10;
  const userCount = userDataSource.length;
  const pageVisited = pageNumber * userPerPage;
  const displayRows = userDataSource.slice(
    pageVisited,
    pageVisited + userPerPage
  );
  const [userId, setUserId] = useState("");
  const [status, setStatus] = useState("");
  const [apiResponse, setApiResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ id: "", status: 0 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpenLoan, setIsDialogOpenLoan] = useState<any>(false);
  const [isDialogOpenLoanList, setIsDialogOpenLoanList] = useState<any>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [userRow_Id, setUserRow_Id] = useState<string>();
  const [rowStatus, setRowStatus] = useState();
  const [filterModel, setFilterModel] = useState({});
  const [teamdata, setTeamData] = useState([]);
  const [passwordReset, setPasswordReset] = useState<any>(false);
  const [passwordResetId, setPasswordResetId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
   const [metaData, setMetaData] = useState<any>({});
    const [paginationModel, setPaginationModel] = React.useState({
      pageSize: 25,
      page: 0,
    });
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    const [portalFilter, setPortalFilter] = useState<string>("all");
    const [moveConfirm, setMoveConfirm] = useState<{
      open: boolean;
      id: string;
      row: any;
    }>({ open: false, id: "", row: null });
    const [moveLoading, setMoveLoading] = useState(false);
    
  useEffect(() => {
    tableDataShowHandler();
  }, [paginationModel, search, portalFilter, activeOrganizationId]);
  // get value from Input field
  interface typeOfTeamdataItem {
    team_name: any;
    _id: any;
  }

  const onClickHandler = () => {
    setUserId("");
    setNewTeamDialog(true);
  };

  const handleEdit = (id: string) => {
    setNewTeamDialog(true);
    setUserId(id);
  };

  const handleChange = (value: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: value.target.value,
      page: 0,
    });
  };

  const handleLoan = (id: string, statusVal: any) => {
    setIsDialogOpenLoan(true);
    setUserId(id);
    setStatus(statusVal);
    setAnchorEl(null);
  };

  const handleCloseLoan = () => {
    setIsDialogOpenLoan(false);
    tableDataShowHandler();
  };

  const handleLoanList = (id: string, statusVal: any) => {
    setIsDialogOpenLoan(false);
    setAnchorEl(null);
    setUserId(id);

    setIsDialogOpenLoanList(true);
    setStatus(statusVal);
  };

  const handleCloseLoanList = () => {
    setIsDialogOpenLoanList(false);
    tableDataShowHandler();
  };

  const changeStatus = async (status: any, id: any) => {
    try {
      const response = await changeStatusApi(status, id);

      customErrorHandler(response);
      openSuccessNotification(response.message);
      setIsDialogOpen(false);
      tableDataShowHandler();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleViewSalary = (user_id: string) => {
    history.push({
      pathname: urls.salarySlipViewPath,
      state: { fromPage: user_id }, //"64807274ee4348490a2181e1"
    });
  };
  const handleSetPassword = (user_id: string) => {
    setPasswordReset(true);
    setPasswordResetId(user_id);
  };
  const handleSetPasswordClose = () => {
    setPasswordReset(false);
  };
  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    user_id: string,
    status: any
  ) => {
    setAnchorEl(event.currentTarget);
    setUserRow_Id(user_id);
    setRowStatus(status);
  };

  const handleClose = () => {
    setAnchorEl(null);
    tableDataShowHandler();
  };
  const getTeamName = (id: any) => {
    const val: any = teamdata.filter(
      (item: typeOfTeamdataItem) => item._id === id
    );
    const ans = val?.length > 0 ? val[0]?.team_name : "";
    return <Typography sx={classes.rowtext}>{ans}</Typography>;
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const columns: YhTableColumn[] = [
    {
      headerName: "Portal",
      field: "portal",
      minWidth: 130,
      flex: 0.6,
      renderCell: (params: YhTableCellParams) => {
        const label = portalLabelFromRow(params.row);
        return (
          <Chip
            size="small"
            label={label}
            color={portalChipColor(label)}
            variant="outlined"
          />
        );
      },
    },
    {
      headerName: "Project Name",
      field: "project_name",
      minWidth:350,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.fullName}>{params.row?.project_name}</Typography>
        </Stack>
      ),
    },
    {
      headerName: "Project Uid",
      field: "project_uid",
      minWidth: 160,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          {(params.row?.project_uid)}
        </Stack>
      ),
    },
    {
      headerName: "Status",
      field: "status",
      minWidth: 140,
      flex: 0.7,
      renderCell: (params: YhTableCellParams) => (
        <Typography sx={{ fontSize: 12 }}>
          {mappingStatusLabel(params.row?.status)}
        </Typography>
      ),
    },
    {
      headerName: "Action",
      field: "action",
      minWidth: 160,
      flex: 0.6,
      renderCell: (params: YhTableCellParams) =>
        Number(params.row?.status) === 2 ? (
          <Button
            size="small"
            style={{ background: "lightBlue" }}
            onClick={() =>
              setMoveConfirm({ open: true, id: params.row._id, row: params.row })
            }
          >
            Move leads
          </Button>
        ) : null,
    },
  ];

  const handelMovingProject = async (id: string) => {
    try {
      setMoveLoading(true);
      const response = await movingProject(id);
      customErrorHandler(response);
      openSuccessNotification(
        response?.message ||
          (response?.promoted
            ? `${response.promoted} lead(s) moved to All Leads`
            : "Move completed")
      );
      setMoveConfirm({ open: false, id: "", row: null });
      tableDataShowHandler();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error?.message) ? error.message : notifiers.GENERIC_ERROR
      );
    } finally {
      setMoveLoading(false);
    }
  };

  const tableDataShowHandler = async () => {
    try {
      setApiResponse(true);
      const response3 = await getTeamList();
      const data3 = response3?.data;
      setTeamData(data3);
      const payload = {
        pageNumber: paginationModel.page,
        pageSize: paginationModel.pageSize,
        search: search || "",
        portal: portalFilter,
      };
      const response = await getAllProject(payload);
      const rawRows = Array.isArray(response?.data) ? response.data : [];
      const rows = filterPortalRows(rawRows, portalFilter);
      setMetaData(
        response?.metadata?.[0]
          ? { ...response.metadata[0], total: response.metadata[0].total ?? rows.length }
          : { total: rows.length, page: paginationModel.page }
      );
      setLoading(true);
      const source = rows.map((userData: any) => {
        return {
          project_name: (
            <>
              <Typography sx={classes.fullName}>{userData?.project_name}</Typography>
             
            </>
          ),

          project_uid: (
            <>
              <Typography sx={classes.rowtext}>
                {userData?.project_uid}
              </Typography>
            </>
          )
        };
      });
      setUserDataSource([...source]);
      setUserDataSource1([...rows]);
      setFixData([...source]);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleCloseAddTeam = () => {
    setNewTeamDialog(false);
    tableDataShowHandler();
  };

  // Account status modal

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUser({ ...selectedUser, status: +event.target.value });
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcon onClick={() => setIsDialogOpen(false)} />
      </Box>
    );
  };
  const handelDateRange = async (value: any) => {
    // console.log((value[0]),"newvalue")
    // console.log((value[1]),"newvalue")
   
    const from = value[0]?.format("DD/MM/yyyy");
    const to = value[1]?.format("DD/MM/yyyy");
    if (from && to) {
      try {
        const response = await getDateWiseTeam(
          store.getState().auth.userId,
          from,
          to
        );
        customErrorHandler(response);
        let totalTime: any = "0:0";

        const source = response.data.map((userData: any) => {
          return {
            name: (
              <>
                <Typography sx={classes.fullName}>{userData?.name}</Typography>
                {userData?.userOffices[0]?.emp_type ? (
                  <Typography sx={classes.emp_type_btn}>
                    {userData?.userOffices[0]?.emp_type}
                  </Typography>
                ) : (
                  ""
                )}
                {userData?.in_complete && (
                  <Typography sx={classes.Info_btn}>
                    Information incomplete
                  </Typography>
                )}
              </>
            ),

            Designation: (
              <>
                <Typography sx={classes.rowtext}>
                  {userData?.userOffices[0]?.designation}
                </Typography>
                <Typography sx={[classes.rowtext, classes.dipt]}>
                  {userData?.userOffices[0]?.department}
                </Typography>
              </>
            ),
            email: (
              <>
                <Typography sx={classes.rowtext}>
                  <img src={EmailListIcon} alt="" />
                  {userData.email}
                </Typography>
                <Typography sx={classes.rowtext}>
                  <img src={PhoneListIcon} alt="" />
                  {userData.phone}
                </Typography>
                <Typography sx={classes.rowtext}>
                  <img src={PhoneListIcon} alt="" />
                  {userData.whatsapp}
                </Typography>
              </>
            ),

            location: (
              <Typography sx={classes.rowtext}>
                {userData.city}, {userData.states[0]?.state_name} <br />{" "}
                {userData.countries[0]?.country_name}{" "}
              </Typography>
            ),
            dob: (
              <>
                {/* <Typography sx={classes.rowtext}>
                Joining Date: {userData?.userOffices[0]?.joining}
              </Typography> */}
                <Typography sx={classes.rowtext}>
                  Birthday: {userData?.dob}
                </Typography>
              </>
            ),

            LeaveBalance: (
              <>
                <Typography sx={classes.rowtext}>
                  Total Leave : {userData?.leaves[0]?.total_leave_available}
                </Typography>

                <Typography sx={classes.rowtext}>
                  Sick Leave: {userData?.leaves[0]?.sick_leave_available}
                </Typography>

                <Typography sx={classes.rowtext}>
                  Casual Leave: {userData?.leaves[0]?.casual_leave_available}
                </Typography>
              </>
            ),

            status: (
              <>
                {privileges &&
                (privileges?.["Team List"]?.includes("delete") ||
                  privileges?.["Team List"]?.includes("full control")) ? (
                  <Box
                    sx={
                      userData.status == 0
                        ? classes.deActive
                        : classes.activeBtn
                    }
                  >
                    <CustomButton
                      label={userData.status == 0 ? "Deactive" : "Active"}
                      buttonType="primaryBtn"
                      onClick={() => {
                        changeStatus(userData.status, userData.user_id);
                      }}
                    />
                  </Box>
                ) : (
                  ""
                )}
              </>
            ),

            action: (
              <>
                <Box sx={classes.verticalDotButton}>
                  <Button
                    onClick={(event: any) =>
                      handlePopOver(event, userData._id, userData.status)
                    }
                  >
                    <VerticalDotIcon />
                  </Button>
                </Box>
                {/* <Box sx={classes.buttonWrapper}>
                <CustomButton
                  label="Edit"
                  buttonType="iconBtn"
                  onClick={() => {
                    handleEdit(userData._id);
                  }}
                />

                <CustomButton
                  label="Add Loan"
                  buttonType="iconBtn"
                  onClick={() => handleLoan(userData?._id, userData?.status)}
                />

                <CustomButton
                  label="View Salary"
                  buttonType="iconBtn"
                  onClick={() => handleViewSalary(userData?.user_id)}
                />
              </Box> */}
              </>
            ),
          };
        });
        setUserDataSource([...source]);
        const source1 = response.data.map((userData: any) => {
          return userData;
        });
        setUserDataSource1([...source1]);
        setFixData([...source]);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };
  const updateDetails = async (type: any) => {
    try {
      if (passwordConfirm.length && passwordConfirm === password) {
        const response2 = await changeUserPassword({
          id: passwordResetId,
          password: password,
        });
        openSuccessNotification(response2.message);

        handleSetPasswordClose();
      } else {
        openErrorNotification("Value Not Matched");
      }
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.content}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={classes.pageHeading}>Account Status</Typography>
              <Typography sx={classes.pageSubHeading}>
                Change your account status
              </Typography>
            </Grid>
            {/* <DateRangePicker localeText={{ start: 'Check-in', end: 'Check-out' }} /> */}
            <Grid item xs={12} mt={5}>
              <Typography sx={classes.statusHeading}>Current Status</Typography>

              <Box sx={classes.checkBoxWarapper}>
                <CustomRadioButton
                  value={1}
                  checked={selectedUser.status == 1}
                  onChange={handleRadioChange}
                  label="Active"
                />

                <CustomRadioButton
                  value={0}
                  checked={selectedUser.status == 0}
                  onChange={handleRadioChange}
                  label="Deactive"
                />
              </Box>

              <Box>
                <CustomButton
                  onClick={() => {
                    // handleDeleteAccount();
                  }}
                  label="Delete Account"
                  buttonType="iconBtn"
                  customClasses={{ color: "red" }}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={classes.buttonWrapperDialog}>
                <CustomButton
                  label="Save"
                  onClick={() => {}}
                  buttonType="primaryBtn"
                />
                <CustomButton
                  label="Cancel"
                  onClick={() => {
                    setIsDialogOpen(false);
                  }}
                  buttonType="secondaryBtn"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };
  const getShowAllPage = () => {
    return (
      <>
        <Box sx={classes.showAllWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Grid container columnSpacing={5}>
                <Grid item xs={12} mt={2} mb={4}>
                  <Box sx={classes.menuPart}>
                  
                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sx={customTableClasses.tableGridPart}>
                  <Box sx={{ mb: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {PORTAL_FILTERS.map((p) => (
                      <Button
                        key={p.id}
                        size="small"
                        variant={portalFilter === p.id ? "contained" : "outlined"}
                        onClick={() => {
                          setPortalFilter(p.id);
                          setPaginationModel((prev) => ({ ...prev, page: 0 }));
                        }}
                      >
                        {p.label}
                      </Button>
                    ))}
                  </Box>
                  <Typography sx={{ mb: 1.5, fontSize: 13, color: "#6B7280" }}>
                    Portal projects already linked to a CRM project and lead form
                    (<code>MB_</code> Magic Bricks, <code>HC_</code> Housing,{" "}
                    <code>AC_</code> 99 Acres). Rows still waiting for a project
                    or a lead form stay on Un Mapped Project.
                  </Typography>
                  <Box sx={{ mb: 2, maxWidth: 420 }}>
                    <YhInput
                      placeholder="Search"
                      type="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      autoFocus={isSearchFocused}
                      startAdornment={<SearchSvg />}
                      onFocus={() => setIsSearchFocused(true)}
                      onBlur={() => setIsSearchFocused(false)}
                    />
                  </Box>
                  {privileges &&
                    (privileges?.["Team List"]?.includes("view") ||
                      privileges?.["Team List"]?.includes("full control")) ? (
                    <>
                      <YhTable
                        key={`existing-${portalFilter}-${paginationModel.page}`}
                        columns={columns}
                        rows={userDataSource1 || []}
                        getRowId={(row) => row._id}
                        rowHeight={70}
                        loading={apiResponse}
                        emptyMessage="No portal configs found"
                        className="min-h-[320px]"
                        page={paginationModel.page}
                        pageSize={paginationModel.pageSize}
                        totalRows={metaData?.total || 0}
                        onPageChange={(p) =>
                          setPaginationModel((prev) => ({ ...prev, page: p }))
                        }
                        onPageSizeChange={(s) =>
                          setPaginationModel({ pageSize: s, page: 0 })
                        }
                      />
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        sx={{ top: "10px", left: "-20px" }}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <Box sx={classes.innerPopOver}>
                          {privileges &&
                            (privileges?.["Team List"]?.includes("edit") ||
                              privileges?.["Team List"]?.includes(
                                "full control"
                              )) ? (
                            <>
                              <CustomButton
                                label="Edit"
                                buttonType="iconBtn"
                                onClick={() => {
                                  handleEdit(userRow_Id ?? "");
                                }}
                              />
                              <CustomButton
                                label="Add Loan"
                                buttonType="iconBtn"
                                onClick={() =>
                                  handleLoan(userRow_Id ?? "", rowStatus)
                                }
                              />

                              <CustomButton
                                label="View Loan"
                                buttonType="iconBtn"
                                onClick={() =>
                                  handleLoanList(userRow_Id ?? "", rowStatus)
                                }
                              />

                              <CustomButton
                                label="View Salary"
                                buttonType="iconBtn"
                                onClick={() =>
                                  handleViewSalary(userRow_Id ?? "")
                                }
                              />
                            </>
                          ) : (
                            ""
                          )}
                          <CustomButton
                            label="Reset Password"
                            buttonType="iconBtn"
                            onClick={() => handleSetPassword(userRow_Id ?? "")}
                          />
                        </Box>
                      </Popover>
                    </>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {addNewTeamDialog && (
            <AddNewTeam
              isDialogOpen={true}
              handleCloseAddTeam={handleCloseAddTeam}
              userId={userId}
              setUserId={setUserId}
            />
          )}

          {apiResponse && <CustomLoader apiResponse={false} />}
        </Box>
        <CustomDialog
          fullScreen={true}
          isDialogOpen={isDialogOpen}
          dialogHeaderContent={dialogHeaderContent()}
          dialogTitleContent={dialogTitleContent()}
        />

        {isDialogOpenLoan && (
          <AddLoan
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoan}
            userId={userId}
            status={status}
          />
        )}

        {isDialogOpenLoanList && (
          <LoanList
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoanList}
            userId={userId}
            status={status}
          />
        )}
        <Dialog
          open={passwordReset}
          onClose={handleSetPasswordClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="projectName"
              label="Create Password"
              value={password}
              type="Create Password"
              fullWidth
              variant="standard"
              onChange={(e: any) => {
                setPassword(e.target.value);
              }}
            />
          </DialogContent>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="projectName"
              label="Confirm Password"
              value={passwordConfirm}
              type="Confirm Password"
              fullWidth
              variant="standard"
              onChange={(e: any) => {
                setPasswordConfirm(e.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSetPasswordClose}>Cancel</Button>
            <Button
              onClick={() => {
                updateDetails("password");
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={moveConfirm.open}
          onClose={() =>
            !moveLoading && setMoveConfirm({ open: false, id: "", row: null })
          }
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Move leads to All Leads?</DialogTitle>
          <DialogContent>
            <Typography sx={{ fontSize: 14 }}>
              This moves queued portal leads for{" "}
              <strong>{moveConfirm.row?.project_name}</strong> (
              <code>{moveConfirm.row?.project_uid}</code>) into All Leads.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setMoveConfirm({ open: false, id: "", row: null })}
              disabled={moveLoading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={moveLoading}
              onClick={() => handelMovingProject(moveConfirm.id)}
            >
              {moveLoading ? "Moving..." : "Move leads"}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  return getShowAllPage();
};

export default ShowAll;
